// Step3.jsx
import React, { Component } from 'react';
import { Form, Button } from 'semantic-ui-react';
//import $ from 'jquery';

import { withTranslation } from 'react-i18next';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import back from './images/back.svg';

import { zoomIn } from 'react-animations';
import { fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';

const styles = {

    zoomIn: {
        animation: 'x 1s',
        animationName: Radium.keyframes(zoomIn, 'zoomIn')
    }

    ,
    fadeInRight: {
        animation: 'x 1s',
        animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
    }
}



class Step4 extends Component {
   


    saveAndContinue = (e) => {
        e.preventDefault()
        this.props.nextStep()
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }





    render() {
        const { values } = this.props;
        const {t, i18n} = this.props;
 


        return (
            <StyleRoot>  
            <Form onSubmit={this.saveAndContinue} id="questionnaire1">

                <fieldset style={values.next === '' ? styles.zoomIn : styles.fadeInRight}>

                    <div className="col-xl-8 offset-xl-2 mt-5 text-center ">
                            <p className="p-18">4 {t('step.steps')} {values.steps}</p>
                            <h2> {t('step4.thanks')} {values.firstName}, </h2>
                        {
                            values.generaltext_json.map((obj) => {

                                    if (values.steps === 5)
                                        {
                                        return <div key={obj.id} dangerouslySetInnerHTML={{ __html: obj.step4[i18n.language] }}></div>
                                    }
                                    else
                                    {

                                        return <div key={obj.id} dangerouslySetInnerHTML={{ __html: obj.step4_alt[i18n.language] }}></div>

                                    }
                            })

                        } 
                    </div>

                    <div className="col-xl-8 offset-xl-2 mt-5 text-center">
                        <div className="row">

                                <div className="col-xl-6">
                                    <Autocomplete
                                        id="combo-box-lengthofstay"

                                        options={values.lengthofstay_json}
                                        // groupBy={(option) => option.is_in}
                                        size="small"
                                        value={values.lengthofstay_one}
                                        onChange={(event, newValue) => {
                                            // console.log(newValue.id)

                                            this.props.handleChangeAutocompleteLen('length_of_stay', newValue);

                                        }}

                                        //inputValue={values.lengthofstay_one !== null ? values.lengthofstay_one.title[i18n.language] : ''}
                                        onInputChange={(event, newInputValue, reason) => {

                                        }}
                                        renderOption={(option) => option.title[i18n.language]}
                                        getOptionLabel={(option) => option.title[i18n.language]}
                                        //style={{ height: 10 }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            label={t('step4.length_of_stay')}
                                            variant="outlined"

                                            inputProps={{
                                                ...params.inputProps,
                                                required: true,
                                            }}
                                        />}
                                    />
                            </div>

                                <div className="col-xl-6 mt-4 mt-xl-0">
                                    <Autocomplete
                                        id="combo-box-type-insurance"
                                        options={values.type_of_insurance_json}
                                        // groupBy={(option) => option.is_in}
                                        size="small"
                                        value={values.type_of_insurance_one}
                                        onChange={(event, newValue) => {


                                            this.props.handleChangeAutocompleteCats('type_of_insurance', newValue);
                                            

                                        }}


                                        //inputValue={values.type_of_insurance_one !== null ? values.type_of_insurance_one.title[i18n.language] : ''} 
                                        onInputChange={(event, newInputValue, reason) => {



                                        }}
                                        getOptionLabel={(option) => option.title[i18n.language]}
                                        //style={{ width: 300 }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            label={t('step3.type_of_insurance')}
                                            variant="outlined"
                                            id="destination_id"
                                            inputProps={{
                                                ...params.inputProps,
                                                required: true,
                                            }}
                                        />}
                                    />
                            </div>

                        </div>

                       

                        <div className="row">
                            <div className="col-3 d-flex align-items-center">
                                <Button onClick={this.back} className="previous previous-arrow mt-5">
                                    <img src={back} alt="back" className="image-flud" />
                                    <p className="p-14 d-none d-md-block "> {t('btn.back')}</p>
                                </Button>
                            </div>
                            <div className="col-6">
                                    <Button type="submit" className="next btn well_btn mt-4  wow fadeInUp btn-lrg">{t('btn.save')}</Button>
                            </div>
                        </div>
                    </div>

                </fieldset>

            </Form>
            </StyleRoot>  
        )
    }
}

export default withTranslation()(Step4);
